// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"477":"816d114fd16140c6","999":"4af5dd70ba69cb7f"}[chunkId] + ".js";
};